<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm"
	*ngIf="UserModuleAccess==='Full'">
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<mat-form-field appearance="fill">
				<mat-label>Name</mat-label>
				<input matInput placeholder="" formControlName="name">
			</mat-form-field>
			<p *ngIf="showError('name')" class="field-error">
				<mat-error *ngIf="f.name.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</mat-error>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<mat-form-field appearance="fill">
				<mat-label>Email</mat-label>
				<input matInput placeholder="" formControlName="email">
			</mat-form-field>
			<p *ngIf="showError('email')" class="field-error">
				<mat-error *ngIf="f.email.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.email.errors?.pattern">
					Invalid
				</mat-error>
				<mat-error *ngIf="f.email.errors?.incorrect">
					{{customError.email}}
				</mat-error>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="w-50 float-start">
				<ng-select appendTo="body" [items]="countryCodes" bindLabel="display" bindValue="dial_code"
					[clearable]="true" [multiple]="false" id="country_code" formControlName="country_code"
					name="country_code" placeholder="Country Code*" [appearance]="'fill'">
				</ng-select>
				<p *ngIf="showError('country_code')" class="field-error">
					<mat-error *ngIf="f.country_code.errors?.required">
						Required
					</mat-error>
					<mat-error *ngIf="f.country_code.errors?.incorrect">
						{{customError.country_code}}
					</mat-error>
				</p>
			</div>
			<div class="w-50 float-start">
				<mat-form-field appearance="fill">
					<mat-label>Phone Number</mat-label>
					<input matInput placeholder="" formControlName="phone_number">
				</mat-form-field>
				<p *ngIf="showError('phone_number')" class="field-error">
					<mat-error *ngIf="f.phone_number.errors?.required">
						Required
					</mat-error>
					<mat-error *ngIf="f.phone_number.errors?.pattern">
						Invalid
					</mat-error>
					<mat-error *ngIf="f.phone_number.errors?.incorrect">
						{{customError.phone_number}}
					</mat-error>
				</p>
			</div>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<mat-form-field appearance="fill">
				<mat-label>Address</mat-label>
				<input matInput placeholder="" formControlName="address">
			</mat-form-field>
			<p *ngIf="showError('address')" class="field-error">
				<mat-error *ngIf="f.address.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.address.errors?.incorrect">
					{{customError.address}}
				</mat-error>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<ng-select appendTo="body" [items]="countryList" bindLabel="countryName" bindValue="countryID" [clearable]="true"
				[multiple]="false" id="country_id" formControlName="country_id" name="country_id" placeholder="Country*"
				[appearance]="'fill'" (change)="getStatesByCountry()">
			</ng-select>
			<p *ngIf="showError('country_id')" class="field-error">
				<mat-error *ngIf="f.country_id.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.country_id.errors?.incorrect">
					{{customError.country_id}}
				</mat-error>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<ng-select appendTo="body" [items]="stateList" bindLabel="stateName" bindValue="stateID" [clearable]="true"
				[multiple]="false" id="state_id" formControlName="state_id" name="state_id" placeholder="State*"
				[appearance]="'fill'" (change)="getCitiesByState()">
			</ng-select>
			<p *ngIf="showError('state_id')" class="field-error">
				<mat-error *ngIf="f.state_id.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.state_id.errors?.incorrect">
					{{customError.state_id}}
				</mat-error>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<ng-select appendTo="body" [items]="cityList" bindLabel="cityName" bindValue="cityID" [clearable]="true"
				[multiple]="false" id="city_id" formControlName="city_id" name="city_id" placeholder="City*"
				[appearance]="'fill'">
			</ng-select>
			<p *ngIf="showError('city_id')" class="field-error">
				<mat-error *ngIf="f.city_id.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.city_id.errors?.incorrect">
					{{customError.city_id}}
				</mat-error>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>